// extracted by mini-css-extract-plugin
export default {"melodyVideo":"OP-z","isFullWidth":"PP-z","landingPageVideo":"QP-z","play":"RP-z","iframeVideo":"SP-z","playHidden":"TP-z","fullwidth":"UP-z"};